export default __webpack_public_path__ + "static/media/ivy.0c250c92.jpg";